import Environment from '@/config/environment'
import { auth } from '@/config/firebase'
import { signInWithCustomToken, signOut } from 'firebase/auth'

export const loginWithToken = async (token: string) => {
  return await signInWithCustomToken(auth, token)
}

export const checkAuthStatus = async () => {
  const baseApi = Environment.BASE_API
  const response = await fetch(`${baseApi}/authStatus`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  if (!response.ok) {
    throw new Error('Not authenticated')
  }
  return await response.json()
}

export const logout = async (url: string | null = null) => {
  await signOut(auth)
  localStorage.clear()
  location.href = url ?? Environment.LOGIN_URL
}
